import { ContenuPosePushTutosNotices } from '@components/contenu-pose-push-tutos-notices/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

const listItems = [
  `avant la pose, un professionnel se rend chez vous pour prendre les mesures`,
  `il s'assure que le plan de votre cuisine respecte bien les contraintes et dimensions`,
  `on vous a concocté une batterie de conseils d'expert pour vous aider à poser comme un chef !`,
];

const getText = () => {
  let items = '';
  for (const item of listItems) {
    items += `<li>${item}</li>`;
  }
  return `<ul>${items}</ul>`;
};

export const contenuPosePushTutosNoticesMock: Block<ContenuPosePushTutosNotices> = {
  type: 'contenu-pose-push-tutos-notices',
  data: {
    titleWithText: {
      title: {
        text: 'Vous posez vous-même votre cuisine... mais pas tout seul !',
        as: 'h2',
      },
      text: getText(),
    },
    tutos: {
      title: { text: 'Tutos, tous nos conseils en vidéo', as: 'h2' },
      cards: [
        {
          image: imageMock,
          cta: {
            label: 'Je prépare la pose de ma cuisine équipée',
            url: '/mock-tutos/je-prepare-la-pose-de-ma-cuisine-equipee',
          },
        },
        {
          image: imageMock,
          cta: {
            label: 'Je pose un plan de travail en vidéo',
            url: '/mock-tutos/je-pose-un-plan-de-travail-en-video',
          },
        },
      ],
      cta: {
        label: 'Voir tous nos tutos',
        url: '/mock-tutos',
      },
    },
    manuals: {
      title: {
        text: 'Tutos, notices, guides ... Ma boite à outils pour poser ma cuisine comme un pro.',
        as: 'h2',
      },
      cards: [
        {
          image: imageMock,
          cta: {
            label: 'Le guide de pose',
            url: 'https://www.w3.org/',
          },
        },
        {
          image: imageMock,
          cta: {
            label: 'Les notices de pose',
            url: 'https://www.w3.org/',
          },
        },
      ],
    },
    cta: {
      label: 'Voir la formule “je fais poser”',
      url: '/mock-la-pose/pro',
    },
  },
};
